import { useField } from "formik";
import React from "react";
import { FieldProps } from "../Questionnaire/TextField";
import { FormField } from "./FormField";
import { SwitchField } from "./SwitchField";

export const CheckboxField = ({ name, field }: FieldProps) => {
    const [props, , helpers] = useField(name);

    return (
        <FormField name={name} label={field.label}>
            <SwitchField
                isChecked={!!props.value}
                onChange={(value) => {
                    helpers.setValue(value);
                }}
            >
                {field.label}
            </SwitchField>
        </FormField>
    );
};
